import React from 'react';
import block from 'bem-cn';
import './TableHead.scss';

const TableHead = ({ locale }) => {
  const b = block('table-head-promotions');

  return (
    <div className={b()}>
      <div className={b('table-head')}>{locale.image}</div>
      <div className={b('table-head')}>URL</div>
      <div className={b('table-head')}>{locale.publicationDate}</div>
      <div className={b('table-head')}>{locale.deactivationDate}</div>
      <div className={b('table-head')}>{locale.language}</div>
      <div className={b('table-head')}>{locale.active}</div>

      <div className={b('table-head')}>{locale.manage}</div>
    </div>
  );
};

export default TableHead;
